<div class="row">
  <div class="col-12">
    <p class="mbottom-12">
      <transloco id="7174ad8d-c574-4db8-aa25-f3f96b63d66a" key="accountUi.declineNewTermsUi.declineConsequences"></transloco>
    </p>
  </div>
</div>
<yat-buttons
  [primaryButtonName]="'accountUi.declineNewTermsUi.declineTerms' | transloco"
  [secondaryButtonName]="('back' | commonWording | async) ?? ''"
  (primaryButtonClickMethod)="decline()"
  (secondaryButtonClickMethod)="back()"
  [negativePrimaryButton]="true">
</yat-buttons>
